var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-temp',{attrs:{"widgetTitle":"Danh sách bao hàng","widgetName":"BigpackageSummary","widgetId":1}},[_c('template',{slot:"widget-content"},[_c('div',{staticClass:"performance-block"},[_c('div',{staticClass:"row"},[_c('bigpackage-list',{attrs:{"dashboard_pagination":_vm.pagination}})],1)])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }